// Number / percent / currency formatting helpers (Phase 5 leaf module).
// NOTE: formatPctHTML emits Tailwind classes (text-emerald-400 / text-rose-400) — tailwind.config
// content must scan src/**/*.js so these aren't purged.
export const formatVol = (v) => {
    if (!v) return "0";
    if (v >= 1000000) return (v / 1000000).toFixed(2) + 'M';
    if (v >= 1000) return (v / 1000).toFixed(1) + 'K';
    return v.toLocaleString();
};
export const formatBig = (v) => {
    if (v === null || v === undefined || isNaN(v) || v === 0) return "--";
    if (v >= 1e12) return (v / 1e12).toFixed(2) + 'T';
    if (v >= 1e9)  return (v / 1e9).toFixed(2) + 'B';
    if (v >= 1e6)  return (v / 1e6).toFixed(2) + 'M';
    if (v >= 1e3)  return (v / 1e3).toFixed(1) + 'K';
    return v.toFixed(0);
};
export const formatDollarBig = (v) => (v === null || isNaN(v) || v === 0) ? "--" : "$" + formatBig(v);
export const formatPctHTML = (val, suffix = "%") => {
    if (val === null || isNaN(val)) return "--";
    const color = val >= 0 ? "text-emerald-400" : "text-rose-400";
    return `<span class="${color}">${val >= 0 ? '+' : ''}${val.toFixed(2)}${suffix}</span>`;
};
